import styled, { css } from 'styled-components';

export const Stack = styled.div`
  position: fixed;
  right: 1.5rem;
  bottom: 12rem;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  transition: opacity 0.2s ease;

  @media (max-width: 600px) {
    right: 1rem;
    bottom: 6rem;
    gap: 0.5rem;
  }

  /* Hide the floating WhatsApp button while the mobile menu drawer is open,
     so it doesn't overlap the language/currency controls in the drawer footer. */
  body.mobile-menu-open & {
    opacity: 0;
    pointer-events: none;
  }
`;

export const BadgeTooltip = styled.span`
  position: absolute;
  right: calc(100% + 12px);
  top: 50%;
  transform: translateY(-50%) translateX(8px);
  background: #1a1a1a;
  color: #fff;
  font-family: 'Abel', sans-serif;
  font-size: 0.75rem;
  letter-spacing: 0.04em;
  padding: 0.45rem 0.7rem;
  border-radius: 4px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.18s ease, transform 0.18s ease;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.25);

  &::after {
    content: '';
    position: absolute;
    left: 100%;
    top: 50%;
    transform: translateY(-50%);
    border: 6px solid transparent;
    border-left-color: #1a1a1a;
  }

  @media (max-width: 720px) {
    display: none;
  }
`;

export const Badge = styled.a<{ $primary?: boolean }>`
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1a1a1a;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.16);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease, color 0.2s ease;

  svg { width: 22px; height: 22px; display: block; }

  ${({ $primary }) => $primary && css`
    background: #25D366;
    color: #fff;
    width: 52px;
    height: 52px;
    box-shadow: 0 4px 14px rgba(37, 211, 102, 0.4);
  `}

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 22px rgba(0, 0, 0, 0.25);
  }

  &:hover > span {
    opacity: 1;
    transform: translateY(-50%) translateX(0);
  }

  @media (max-width: 600px) {
    width: 42px;
    height: 42px;
    svg { width: 20px; height: 20px; }

    ${({ $primary }) => $primary && css`
      width: 46px;
      height: 46px;
    `}
  }
`;

export const WhatsAppImg = styled.img`
  width: 26px;
  height: 26px;
  object-fit: contain;

  @media (max-width: 600px) {
    width: 22px;
    height: 22px;
  }
`;
